export default __webpack_public_path__ + "static/media/client29.6872848b.png";